
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }: any) {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL || '/api';
    fetch(`${apiUrl}/auth/me`, {
      method: 'GET',
      credentials: 'include',
    })
      .then(res => {
        if (res.ok) return res.json();
        throw new Error('Unauthorized');
      })
      .then(() => {
        setIsAuth(true);
      })
      .catch(() => {
        setIsAuth(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) return <div>Завантаження...</div>;

  if (!isAuth) return <Navigate to="/admin/login" replace />;

  return children;
}
